// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wXl9","index":"styles_index__1aYx2"};